// @flow
import { DeviceInfoPanelHeading, DeviceInfoPanelList, DeviceInfoPanelListItem, DeviceInfoPanelValue } from './styles';

import type { DeviceProps } from './types';
import { FormattedMessage } from 'react-intl';
import messages from '../intl';
import * as React from 'react';

type Props = {
    device: DeviceProps,
    serialNumber: string,
    connectedDevices: number
};

const HueBridgeInfoPanel = ({ device: { version, ipAddress }, serialNumber, connectedDevices }: Props) => {
    return (
        <DeviceInfoPanelList>
            <DeviceInfoPanelListItem>
                <DeviceInfoPanelHeading>
                    <FormattedMessage {...messages.manufacturer} />
                    :
                </DeviceInfoPanelHeading>
                <DeviceInfoPanelValue>
                    <FormattedMessage {...messages.philips} />
                </DeviceInfoPanelValue>
            </DeviceInfoPanelListItem>
            <DeviceInfoPanelListItem>
                <DeviceInfoPanelHeading>
                    <FormattedMessage {...messages.ipAddress} />
                    :
                </DeviceInfoPanelHeading>
                <DeviceInfoPanelValue>{ipAddress}</DeviceInfoPanelValue>
            </DeviceInfoPanelListItem>
            <DeviceInfoPanelListItem>
                <DeviceInfoPanelHeading>
                    <FormattedMessage {...messages.serialNumber} />
                    :
                </DeviceInfoPanelHeading>
                <DeviceInfoPanelValue>{serialNumber}</DeviceInfoPanelValue>
            </DeviceInfoPanelListItem>
            <DeviceInfoPanelListItem>
                <DeviceInfoPanelHeading>
                    <FormattedMessage {...messages.connectedDevices} />
                    :
                </DeviceInfoPanelHeading>
                <DeviceInfoPanelValue>
                    {`${connectedDevices} `}
                    <FormattedMessage {...messages.connectedDevices} value={{ connectedDevices }} />
                </DeviceInfoPanelValue>
            </DeviceInfoPanelListItem>
        </DeviceInfoPanelList>
    );
};

export default HueBridgeInfoPanel;



// WEBPACK FOOTER //
// ./src/components/widgets/device-info-panel/panel-list/hue-bridge.js